import React, { ReactElement, ReactNode } from "react";

import { PieceResponseDTOMin, PieceResponseDTOSimple } from "../../openapi-generated-client";
import PieceDisplay, { PieceDisplayProps } from "./pieceDisplay";
import "./pieceList.css";

interface PieceListProps {
    pieces: Array<
    | PieceResponseDTOSimple
    | PieceResponseDTOMin
    | {
        piece: PieceResponseDTOSimple | PieceResponseDTOMin; // Required PieceResponseDTOSimple object
        wrapper?: Element | ReactElement; // Optional React element as a wrapper
    }>;

    children?: ReactNode;

    displayProps?: PieceDisplayProps;
}

export type { PieceListProps };

export default function PieceList(props: PieceListProps) {
    return <>
        <div className={"piece-list marginBottom"}>
            {props.children}
            {props.pieces.length == 0 ? "No pieces found." : ""}
            {props.pieces.map(p => {
                var piece, wrapper;
                if(typeof p !== "object" || !("piece" in p)) {
                    piece = p;
                    wrapper = undefined;
                }else {
                    piece = p.piece;
                    wrapper = p.wrapper;
                }
                var pieceDisplay = React.cloneElement(<PieceDisplay/>, {
                    ...props.displayProps,
                    pieceData: piece
                })
                if(wrapper) {
                    if (React.isValidElement(wrapper)) {
                        return React.cloneElement(
                            wrapper,
                            {}, // Keeps the original props
                            ...React.Children.toArray((wrapper.props as any).children), // Spread the original children into the array
                            pieceDisplay // Add the new child
                        );
                    }
                    return pieceDisplay;
                }else {
                    return pieceDisplay;
                }
            })}
        </div>
    </>;

}
